import { defineComponent, reactive, onMounted, ref } from 'vue';
import Footer from '../components/Footer.vue';
import { getSoftwareList, getApprovalRecord } from '@/http/api';
import router from '@/router';
// defineComponent 可以有智能提示
export default defineComponent({
  components: {
    Footer
  },
  setup() {
    let user = reactive({});
    let softwareList = ref([]);
    let listFlag = ref(false);
    let refuseVisible = ref(false);
    let comments = ref('');
    const userStr = localStorage.getItem('user');
    if (userStr) {
      user = JSON.parse(userStr);
    }
    onMounted(async () => {
      // 水滴 主页-页面曝光
      window._sdi.stat({
        ptype: '9',
        stype: '12'
      });
      const res = await getSoftwareList();
      if (res.code == 200 && res.result) {
        // 测试用
        window.isCommercial = 1;
        softwareList.value = res.data;
        if (res.data.length > 0) {
          listFlag.value = true;
        } else {
          listFlag.value = false;
        }
      }
      if (user.confirmed === 0) {
        const res = await getApprovalRecord();
        if (res.code == 200 && res.result) {
          comments.value = res.data[0].comments || '';
        }
      }
    });
    const log_add = value => {
      user;
      softwareList;
      listFlag.value;
      // 水滴 主页-新增软件按钮点击
      window._sdi.stat({
        ptype: '9',
        stype: '7'
      });
      router.push({
        path: '/deveaddsoftware'
      });
    };
    const refuseReason = () => {
      // 水滴 主页-资料审核被驳回——查看理由按钮点击
      window._sdi.stat({
        ptype: '9',
        stype: '14'
      });
      refuseVisible.value = true;
    };
    const onConfirm = () => {
      // 水滴 主页-资料审核被驳回——去修改按钮点击
      window._sdi.stat({
        ptype: '9',
        stype: '15'
      });
      const typeflag = user.identityType;
      if (typeflag == 1) {
        router.push({
          path: '/personaledit'
        });
      } else if (typeflag == 2) {
        router.push({
          path: '/companyedit'
        });
      }
      refuseVisible.value = false;
    };
    const goToAdLibrary = () => {
      router.push('/adSoftwareLibrary');
    };
    return {
      goToAdLibrary,
      user,
      listFlag,
      softwareList,
      companybg: require('../assets/imgs/companybg.png'),
      personbg: require('../assets/imgs/personbg.png'),
      log_add,
      router,
      refuseReason,
      onConfirm,
      refuseVisible,
      comments
    };
  }
});